import template from './coworking-workplace-count.jade';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.coworkingWorkplaceCount', [])
  .directive('cianAfAboutObjectCoworkingWorkplaceCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.limitMin = 0;
      this.limitMax = 1000000;

      this.validation = validation(this.form, 'workplaceCount', {
        parse: 'Введите число',
        required: 'Введите количество рабочих мест',
        min: 'Число должно быть больше 0',
        max: 'Допустимо не более 6 символов',
      });
    },
    controllerAs: 'ctrl',
    template,
  })).name;
